export default __webpack_public_path__ + "static/media/emptyIcon.03bd8245.png";